import { useState } from "react";
import Header from "../shared/components/Header";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import Pagos from "./Pagos/index.js";
import Conciliaciones from "./Pagos/Conciliaciones/index.js";


export default function Finanzas() {
    const [tab, setTab] = useState('pagos');

    return (
        <div className="content pt-3">
            <Header viewSearch={false} />

            <TabContext value={tab}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={(e, tab) => setTab(tab)} aria-label="Finanzas">
                        <Tab label="Pagos" value="pagos" />
                        <Tab label="Conciliaciones" value="conciliaciones" />
                    </TabList>
                </Box>
                <TabPanel value="pagos">
                    <Pagos />
                </TabPanel>
                <TabPanel value="conciliaciones">
                    <Conciliaciones />
                </TabPanel>
            </TabContext>
        </div>
    );
}